import { render, staticRenderFns } from "./ProjectsByText.vue?vue&type=template&id=70e0bbec&lang=pug&"
import script from "./ProjectsByText.vue?vue&type=script&lang=js&"
export * from "./ProjectsByText.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsByText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports